import { SxProps, Theme, alpha } from '@mui/material/styles'
import colors from 'styles/colors'

export const styles = {
  buttonContrast: {
    backgroundColor: 'contrast.main',
    color: 'contrast.contrastText',
    '&:hover': {
      backgroundColor: 'contrast.hover',
    },
  } as SxProps<Theme>,
  buttonPrimary: {
    '&:hover': {
      backgroundColor: 'primary.hover',
    },
  } as SxProps<Theme>,
  icon: {
    width: 'auto',
    height: '20px',
  } as SxProps<Theme>,
  buttonProgress: {
    color: colors?.risikaContrast,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -10,
    marginLeft: -8,
  } as SxProps<Theme>,
  leftIcon: {
    marginRight: '10px',
  } as SxProps<Theme>,
  newFeature: {
    fontSize: '12px',
    color: colors?.risikaWhite,
    backgroundColor: colors?.red,
    padding: '5px',
    borderRadius: '5px',
    marginLeft: '10px',
  } as SxProps<Theme>,
}

interface CustomButtonProps {
  color?: string
}

export const getCustomButtonStyles = (props: CustomButtonProps, theme: Theme): SxProps<Theme> => ({
  root: {
    padding: theme.spacing(1.3, 2),
    fontSize: theme.typography.htmlFontSize,
    lineHeight: 0,
    fontWeight: 500,
    textTransform: 'none',
    boxShadow: 'none',
  },
  contained: {
    backgroundColor: props.color
      ? (theme.palette as any)[props.color]?.main
      : colors?.risikaLight,
    color: props.color
      ? (theme.palette as any)[props.color]?.contrastText
      : theme.palette.text.primary,
    '&:hover': {
      backgroundColor: props.color
        ? alpha((theme.palette as any)[props.color]?.main || '#000', 0.8)
        : alpha(colors?.risikaLight || '#000', 0.8),
    },
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    lineHeight: 1,
    justifyContent: 'center',
  },
})
